import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { MenuMusic } from "@/components/MenuMusic";
import { apiError } from "@/lib/api";
import { LandingScene } from "@/components/LandingScene";
import { FilmSignup } from "@/components/FilmSignup";

const Corners = () => ["-top-1 -left-1", "-top-1 -right-1", "-bottom-1 -left-1", "-bottom-1 -right-1"].map((p) => <span key={p} className={`pixel-panel-corner ${p}`} />);

export default function AuthPage() {
  const { authenticate } = useAuth();
  const [mode, setMode] = useState("login");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const login = mode === "login";

  const submit = async (e) => {
    e.preventDefault(); setError(""); setBusy(true);
    try { await authenticate(mode, username, password); } catch (err) { setError(apiError(err)); }
    setBusy(false);
  };

  return (
    <div className="relative min-h-screen overflow-hidden flex items-center justify-center lg:justify-start px-5 sm:px-12 lg:px-24 pt-14 pb-24 sm:pb-14" data-testid="auth-page">
      <LandingScene />
      <MenuMusic />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/20 to-transparent pointer-events-none" />
      <div className="absolute inset-0 scanlines pointer-events-none" />
      <p className="absolute bottom-6 right-6 sm:right-12 pixel-text text-lg text-[#7DD3FC] tracking-widest hidden sm:block rise bg-black/70 px-3 py-1" style={{ animationDelay: "400ms" }}>
        // TRANSMISSION LOST — 03:17 AM
      </p>
      <div className="relative z-10 w-full max-w-md pixel-panel p-7 sm:p-9 rise" data-testid="auth-panel">
        <Corners />
        <h1 className="font-blocky text-2xl sm:text-3xl text-[#F3F4F6] leading-snug flicker" data-testid="auth-title">GODS WE CALL</h1>
        <p className="pixel-text text-xl text-[#9CA3AF] mt-4 mb-7">A pixel horror in chapters. {login ? "Sign in to continue your nightmare." : "Create an account to begin."}</p>
        <div className="border-2 border-dashed border-[#7f1d1d] bg-[#7f1d1d]/15 px-4 py-3 mb-7" data-testid="auth-movie-note">
          <p className="font-blocky text-[9px] text-[#DC2626] tracking-widest mb-2">▶ A FEATURE FILM</p>
          <p className="pixel-text text-lg text-[#F3F4F6] leading-snug">Gods We Call will be made into a feature film. Every chapter you play helps make it happen.</p>
          <FilmSignup source="landing" />
        </div>
        <form onSubmit={submit} data-testid="auth-form">
        <label className="font-blocky text-[10px] text-[#9CA3AF] block mb-2">PLAYER NAME</label>
        <input className="pixel-input mb-5" value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="username" data-testid="login-username-input" />
        <label className="font-blocky text-[10px] text-[#9CA3AF] block mb-2">PASSWORD</label>
        <input className="pixel-input mb-3" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
          autoComplete={login ? "current-password" : "new-password"} data-testid="login-password-input" />
        {error && <p className="pixel-text text-xl text-[#DC2626] mb-2" data-testid="auth-error">&gt; {error}</p>}
        <button type="submit" className="pixel-btn w-full mt-5 font-blocky !text-sm py-4" disabled={busy} data-testid="auth-submit-button">
          {busy ? "LOADING..." : <><span className="blink-caret mr-2">▶</span>{login ? "PRESS START" : "NEW GAME"}</>}
        </button>
        <button type="button" className="mt-5 pixel-text text-xl text-[#64748B] hover:text-[#F3F4F6] transition-colors"
          onClick={() => { setMode(login ? "register" : "login"); setError(""); }} data-testid="auth-toggle-mode-button">
          {login ? "> New player? Register" : "> Have a save? Sign in"}
        </button>
        </form>
      </div>
    </div>
  );
}
